import { track } from '@mc/track-event'

// If User sees the Category section
export const trackCategoryPickerViewed = () => track('Category Picker Viewed')
